<template>
    <div class="free-paid-chart" :class="{ fullscreen: fullScreen }">
        <HalfPieChart :series="getSeries()" :colors="['#cb5d0f', '#4213ce', '#c9d906']" />
        <TableView :cols="getCols()" :rows="getRows()" v-if="tableMode" />
        <div class="stats">
            <StatCard title="Total Free" :value="stats.freePlanSiteCount" unit="site" />
            <StatCard title="Total Paid" :value="stats.paidPlanSiteCount" unit="site" />
            <StatCard title="Total Trial" :value="stats.trialPlanSiteCount" unit="site" />
            <StatCard title="Total Suspend" :value="stats.suspendSiteCount" unit="site" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _ from "lodash";
import IconButton from "../../Pages/Settings/components/IconButton.vue";
import HalfPieChart from "../../Pages/Chatbot/pages/reports/charts/HalfPieChart.vue";
import StatCard from "../../Pages/Chatbot/pages/reports/charts/StatCard.vue";
import TableView from "../../Pages/Chatbot/pages/reports/charts/TableView.vue";
import { expertToExcel } from "../../../utils/utils";
import { ADMIN_REPORT_API } from "../../../api/statistics";
import log2 from "../../../utils/log2";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import fscreen from "fscreen";

const log = log2("FreePaidChart");
export default Vue.extend({
    name: "FreePaidChart",
    components: { ChartDoddleIcon, TableView, IconButton, StatCard, HalfPieChart },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            colors: ["#FFBF00"],
            stats: {
                freePlanSiteCount: 0,
                paidPlanSiteCount: 0,
                trialPlanSiteCount: 0,
                suspendSiteCount: 0,
            },
            tableMode: false,
            loading: true,
            loadingInstance: null,
            data: [],
            fullScreen: false,
            cancels: [],
        };
    },
    methods: {
        switchToFullScreenMode() {
            if (this.fullScreen) {
                this.closeFullScreenMode();
            } else {
                const elem = document.querySelector(".free-paid-chart");
                fscreen.requestFullscreen(elem);
                this.fullScreen = true;
            }
        },
        closeFullScreenMode() {
            fscreen.exitFullscreen();
        },
        fetch() {
            this.loading = true;
            this.loadingInstance.show();
            ADMIN_REPORT_API.paidTypeSites(this.filters)
                .then((res) => {
                    log("paymentStatusSites data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getCols() {
            return [
                {
                    key: "paymentMethod",
                    field: "paymentMethod",
                    title: "Ödeme Yöntemi",
                },
                {
                    key: "siteCount",
                    field: "siteCount",
                    title: this.$t("report.siteCount"),
                },
            ];
        },
        getRows() {
            const rows = this.data.map((item) => {
                return [item.paymentMethod, item.siteCount];
            });
            return rows;
        },
        getStats() {
            return {
                freePlanSiteCount: this.data.freePlanSiteCount,
                paidPlanSiteCount: this.data.paidPlanSiteCount,
                trialPlanSiteCount: this.data.trialPlanSiteCount,
                suspendSiteCount: this.data.suspendSiteCount,
            };
        },
        getSeries() {
            // 1695 - 1044 = 651
            // 402 + 116 + 494 + 32 = 1044
            const data = [
                {
                    value: this.data.freePlanSiteCount,
                    //value: 392, 402
                    name: "Free Plans",
                },
                {
                    value: this.data.paidPlanSiteCount,
                    //value: 109, 116
                    name: "Paid Plans",
                },
                {
                    value: this.data.trialPlanSiteCount,
                    //value: 479, 494
                    name: "Trial Plans",
                },
                {
                    value: this.data.suspendSiteCount,
                    //value: 33, 32
                    name: "Suspend Sites",
                },
            ];

            console.log("data..", data);
            return [
                {
                    name: "Access From",
                    type: "pie",
                    radius: ["40%", "70%"],
                    center: ["50%", "70%"],
                    startAngle: 180,
                    endAngle: 360,
                    data,
                },
            ];
        },
        exportToExcel() {
            const data = this.data.map((item) => {
                return [item.siteCount, item.paymentMethod];
            });
            const stats = this.getStats();
            const excelData = [
                ...data,
                {
                    date: "Toplam site",
                    siteCount: stats.TotalSiteCount,
                },
                {
                    date: "Ödeme Yöntemi",
                    siteCount: stats.paymentMethods,
                },
            ];
            expertToExcel(excelData, `site_payment-methods_.xlsx`, "Sheet 1");
        },
    },
    created() {
        const fullscreenCallback = () => {
            console.log("fullscreenCallback", fscreen.fullscreenElement);
            this.fullScreen = fscreen.fullscreenElement !== null;
            this.$forceUpdate();
        };
        fscreen.addEventListener("fullscreenchange", fullscreenCallback);
        this.cancels.push(() => {
            fscreen.removeEventListener("fullscreenchange", fullscreenCallback);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".free-paid-chart"),
            name: "wave",
        });
        this.stats = this.getStats();
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
        data: {
            handler: function (val, oldVal) {
                this.stats = this.getStats();
            },
            deep: true,
        },
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
    },
});
</script>
<style lang="scss">
.free-paid-chart {
    .title {
        display: flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        margin: 0;

        h2 {
            text-align: center;
            font-weight: 700;
            font-size: 40px;
            margin: 0 !important;
        }
    }

    &.fullscreen {
        background-color: #fff;
        padding: 20px;
        overflow-y: scroll;

        .stacked-area-chart {
            height: calc(100vh - 200px);
        }
    }
}
</style>
<style scoped lang="scss">
.free-paid-chart {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .toolbar {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;

            .buttons {
                display: flex;
                border: 1px solid var(--color-border-default);

                .icon-button {
                    padding: 5px;
                    width: 40px;
                    height: 34px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid var(--color-border-default);
                    border-radius: unset !important;

                    &.selected {
                        background-color: var(--color-bg-info-low-hover);

                        i {
                            color: rgb(55, 162, 255);
                        }
                    }

                    &:hover {
                        background-color: var(--color-bg-neutral-pressed);
                    }
                }

                .icon-button:last-child {
                    border-right: none;
                }
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
        }
    }

    .stats {
        display: flex;
        flex-direction: row;
        gap: 10px;
        flex-wrap: wrap;
    }
}
</style>
